import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';
import type { LlmCall } from './llm-call';
import type { EnrichmentApiCall } from './enrichment-api-call';

export type PipelineRun = WithLegacy<{
  contentSourceId: string | null;
  status: string | null;
  errorMessage: string | null;
  downloadTime: number | null;
  transcribeTime: number | null;
  classifyTime: number | null;
  classifyLlmCalls: number | null;
  classifyInputTokens: number | null;
  classifyOutputTokens: number | null;
  extractEntitiesTime: number | null;
  extractEntitiesLlmCalls: number | null;
  extractEntitiesInputTokens: number | null;
  extractEntitiesOutputTokens: number | null;
  enrichTime: number | null;
  saveTime: number | null;
  fetchRatingsTime: number | null;
  llmModel: string | null;
  totalLlmCalls: number | null;
  totalInputTokens: number | null;
  totalOutputTokens: number | null;
  totalCacheReadTokens: number | null;
  totalCacheWriteTokens: number | null;
  totalTime: number | null;
  commitHash: string | null;
  createdAt: string | null;
  llmCalls: LlmCall[];
  enrichmentApiCalls: EnrichmentApiCall[];
  [Type]: 'pipeline-runs';
}>;

export const PipelineRunSchema = withDefaults({
  type: 'pipeline-runs',
  fields: [
    { name: 'contentSourceId', kind: 'attribute', type: 'string' },
    { name: 'status', kind: 'attribute', type: 'string' },
    { name: 'errorMessage', kind: 'attribute', type: 'string' },
    { name: 'downloadTime', kind: 'attribute', type: 'number' },
    { name: 'transcribeTime', kind: 'attribute', type: 'number' },
    { name: 'classifyTime', kind: 'attribute', type: 'number' },
    { name: 'classifyLlmCalls', kind: 'attribute', type: 'number' },
    { name: 'classifyInputTokens', kind: 'attribute', type: 'number' },
    { name: 'classifyOutputTokens', kind: 'attribute', type: 'number' },
    { name: 'extractEntitiesTime', kind: 'attribute', type: 'number' },
    { name: 'extractEntitiesLlmCalls', kind: 'attribute', type: 'number' },
    { name: 'extractEntitiesInputTokens', kind: 'attribute', type: 'number' },
    { name: 'extractEntitiesOutputTokens', kind: 'attribute', type: 'number' },
    { name: 'enrichTime', kind: 'attribute', type: 'number' },
    { name: 'saveTime', kind: 'attribute', type: 'number' },
    { name: 'fetchRatingsTime', kind: 'attribute', type: 'number' },
    { name: 'llmModel', kind: 'attribute', type: 'string' },
    { name: 'totalLlmCalls', kind: 'attribute', type: 'number' },
    { name: 'totalInputTokens', kind: 'attribute', type: 'number' },
    { name: 'totalOutputTokens', kind: 'attribute', type: 'number' },
    { name: 'totalCacheReadTokens', kind: 'attribute', type: 'number' },
    { name: 'totalCacheWriteTokens', kind: 'attribute', type: 'number' },
    { name: 'totalTime', kind: 'attribute', type: 'number' },
    { name: 'commitHash', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
    {
      name: 'llmCalls',
      kind: 'hasMany',
      type: 'llm-calls',
      options: { async: false, inverse: null },
    },
    {
      name: 'enrichmentApiCalls',
      kind: 'hasMany',
      type: 'enrichment-api-calls',
      options: { async: false, inverse: null },
    },
  ],
});
